import { render } from "./PersonRegistrationCompleteView.vue.ts?vue&type=template&id=6b9cafc5&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationCompleteView.vue?vue&type=template&id=6b9cafc5&scoped=true&ts=true"
import script from "./PersonRegistrationCompleteView.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationCompleteView.vue?vue&type=script&lang=ts"
export * from "./PersonRegistrationCompleteView.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationCompleteView.vue?vue&type=script&lang=ts"

import "./PersonRegistrationCompleteView.vue.scss?vue&type=style&index=0&id=6b9cafc5&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationCompleteView.vue?vue&type=style&index=0&id=6b9cafc5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9cafc5"],['__file',"src/apps/core-app-onboarding/views/PersonRegistrationCompleteView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b9cafc5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b9cafc5', __exports__)) {
    api.reload('6b9cafc5', __exports__)
  }
  
  module.hot.accept("./PersonRegistrationCompleteView.vue.ts?vue&type=template&id=6b9cafc5&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./PersonRegistrationCompleteView.vue?vue&type=template&id=6b9cafc5&scoped=true&ts=true", () => {
    api.rerender('6b9cafc5', render)
  })

}


export default __exports__